var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18164 9.78516C7.19626 9.80383 7.21493 9.81894 7.23625 9.82932C7.25757 9.83971 7.28097 9.84511 7.30469 9.84511C7.3284 9.84511 7.35181 9.83971 7.37312 9.82932C7.39444 9.81894 7.41312 9.80383 7.42773 9.78516L9.61523 7.01758C9.69531 6.91602 9.62305 6.76562 9.49219 6.76562H8.04492V0.15625C8.04492 0.0703125 7.97461 0 7.88867 0H6.7168C6.63086 0 6.56055 0.0703125 6.56055 0.15625V6.76367H5.11719C4.98633 6.76367 4.91406 6.91406 4.99414 7.01562L7.18164 9.78516ZM14.4531 9.10156H13.2812C13.1953 9.10156 13.125 9.17188 13.125 9.25781V12.2656H1.48438V9.25781C1.48438 9.17188 1.41406 9.10156 1.32812 9.10156H0.15625C0.0703125 9.10156 0 9.17188 0 9.25781V13.125C0 13.4707 0.279297 13.75 0.625 13.75H13.9844C14.3301 13.75 14.6094 13.4707 14.6094 13.125V9.25781C14.6094 9.17188 14.5391 9.10156 14.4531 9.10156Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.294c4f0f075a8ea28c8a6621b57e59d3.svg";
export { ForwardRef as ReactComponent };